import { Head, Link } from '@inertiajs/react'
import Form from './form.tsx'
import type { UserType } from './types.ts'
import {Button} from "@/components/ui/button.tsx";
import {ArrowLeft} from "lucide-react";

interface NewProps {
  user: UserType
  can_assign_super_admin: boolean
  can_create_user: boolean
}

export default function New({ user, can_assign_super_admin, can_create_user }: NewProps) {
  return (
    <>
      <Head title="Nouvel utilisateur" />

        <div className="space-y-6 p-8">
            <div className="flex items-center gap-4">
                <Link href="/admin/users">
                    <Button variant="ghost" size="sm">
                        <ArrowLeft className="mr-2 h-4 w-4" />
                        Retour
                    </Button>
                </Link>
                <div>
                    <h1 className="text-3xl font-bold text-foreground">Ajouter un nouveau utilisateur</h1>
                    <p className="text-muted-foreground">Créer un nouveau utilisateur</p>
                </div>
            </div>

        <Form
          user={user}
          canAssignSuperAdmin={can_assign_super_admin}
          canCreateUser={can_create_user}
          method="post"
          action="/admin/users"
          submitText="Créer un utilisateur"
        />


      </div>
    </>
  )
}
